import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app/App";
// import ReactGA from "react-ga4";
// import reportWebVitals from "./reportWebVitals";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["en", "fr", "ar", "kur"],
    // lng: document?.querySelector("html")?.lang, // if you're using a language detector, do not define the lng option
    // fallbackLng: savedLanguage !== null ? savedLanguage : "en",
    detection: {
      order: [
        "cookie",
        "htmlTag",
        "localStorage",
        "sessionStorage",
        "path",
        "subdomain",
      ],
      caches: ["cookie", "localStorage"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation-v5.1.50.json",
    },
    react: { useSuspense: false },
  });
// ReactGA.initialize("G-12KFQWY5HB");
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// if (process.env.NODE_ENV !== "development") {
//   console.log = () => {};
// }
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
